@if (prescriptionChanges().length > 0) {
  <div class="flex flex-col gap-2">
    @for (prescriptionChange of prescriptionChanges(); track prescriptionChange.id) {
      <prescriptions-changes-list-item [prescriptionChange]="prescriptionChange" />
    }
  </div>
} @else {
  <p>{{ "prescription.message.historyListEmpty" | translate }}</p>
}
